import { formatCurrency, formatNumber } from 'utils/intlNumber'
import TitleSubtitleSkeleton from '../Skeletons/TitleSubtitleSkeleton'
import * as Styles from './styles'

export interface INumberCardProps {
  id?: string
  title?: string
  number?: string | number
  isCurrency?: boolean
  isLoading?: boolean
}

const NumberCard: React.FC<INumberCardProps> = ({
  id = 'default',
  title = 'Title',
  number = 0,
  isCurrency = false,
  isLoading = false
}) => {
  return (
    <Styles.ItemContainer data-testid={`components-ui-number-card-${id}`}>
      <Styles.ItemNumber>
        <TitleSubtitleSkeleton isLoading={isLoading}>
          <>
            <Styles.ItemTitle>{title}</Styles.ItemTitle>
            {isCurrency
              ? formatCurrency(Number(number))
              : formatNumber(Number(number))}
          </>
        </TitleSubtitleSkeleton>
      </Styles.ItemNumber>
    </Styles.ItemContainer>
  )
}

export default NumberCard
